import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const cars = [
  {
    img: "Dzire.jpg",
    name: "Swift Dzire",
    price: "₹12/km",
    oldPrice: "₹14/km",
    capacity: "4 Seater",
  },
  {
    img: "ertiga.jpg",
    name: "Maruti Ertiga",
    price: "₹15/km",
    oldPrice: "₹18/km",
    capacity: "6 Seater",
  },
  // {
  //   img: "innova.jpg",
  //   name: "Innova Cab",
  //   price: "₹17/km",
  //   oldPrice: "₹22/km",
  //   capacity: "7 Seater",
  // },
  // {
  //   img: "crysta.jpg",
  //   name: "Innova Crysta",
  //   price: "₹18/km",
  //   oldPrice: "₹24/km",
  //   capacity: "7 Seater",
  // },
  // {
  //   img: "tempo.jpg",
  //   name: "Tempo Traveller",
  //   price: "₹25/km",
  //   oldPrice: "₹30/km",
  //   capacity: "12 Seater",
  // },
];

const FleetDiscover = () => {

  const handleWhatsApp = (carName) => {
    const phone = "919529877342";
    const msg = `Hello, I want to book ${carName} from Royal Route Cab.`;
    window.open(`https://wa.me/${phone}?text=${encodeURIComponent(msg)}`);
  };

  return (
    <section
      className="tour-descover-section section-padding fix bg-cover"
      style={{
        backgroundImage: "url(/images/cab-bg.jpg)",
      }}
    >
      <div className="container">
        <div className="tour-discover-wrapper">
          <div className="row g-4">

            {/* LEFT CONTENT */}
            <div className="col-xl-5">
              <div className="tour-content lg-center">
                <div className="section-title">
                  <span className="wow fadeInUp">
                    Royal Route Cab Fleet
                  </span>

                  <h2 className="wow fadeInUp" data-wow-delay=".3s">
                    Choose Your Perfect Ride <br /> For Every Journey
                  </h2>

                  <p className="mt-3 wow fadeInUp" data-wow-delay=".5s">
                    From budget-friendly sedans to luxury SUVs and spacious
                    travellers, we provide the perfect vehicle for every trip.
                    Enjoy safe, comfortable, and reliable rides with us.
                  </p>
                </div>

                {/* <div className="tour-button mt-3">
                  <a
                    href="/booking"
                    className="theme-btn wow fadeInUp"
                    data-wow-delay=".5s"
                  >
                    <span>Book Your Cab</span>{" "}
                   <i className="fas fa-long-arrow-right"></i>
                  </a>
                </div> */}
              </div>
            </div>

            {/* RIGHT SLIDER */}
            <div className="col-xl-7">
              <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={20}
                slidesPerView={2}
                loop={true}
                autoplay={{ delay: 2500 }}
                pagination={{ clickable: true }}
                breakpoints={{
                  320: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                }}
              >
                {cars.map((car, index) => (
                  <SwiperSlide key={index}>
                    <div className="tour-card-item">

                      {/* Image */}
                      <div className="tour-image">
                        <img
                          src={`/images/fleets/${car.img}`}
                          alt={car.name}
                        />
                      </div>

                      {/* Content */}
                      <div className="tour-content">
                        <h6>
                          Starting <span>{car.price}</span>{" "}
                          <del>{car.oldPrice}</del>
                        </h6>

                        <h4>{car.name}</h4>

                        <ul>
                          <li>
                            <i className="far fa-user"></i>
                            {car.capacity}
                          </li>
                        </ul>

                        <div className="list">
                          <button
                            className="theme-btn text-white"
                            onClick={() => handleWhatsApp(car.name)}
                          >
                            Book Now
                          </button>
                        </div>

                      </div>

                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default FleetDiscover;